import { render, staticRenderFns } from "./onestukq.vue?vue&type=template&id=59e673b4&scoped=true"
import script from "./onestukq.vue?vue&type=script&lang=js"
export * from "./onestukq.vue?vue&type=script&lang=js"
import style0 from "./onestukq.vue?vue&type=style&index=0&id=59e673b4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59e673b4",
  null
  
)

export default component.exports